import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Paths, ProjectPathParams } from '../../app/router/app.router';
import { PermissionBoundary } from '../../core/permissions/permission-boundary.component';
import { ListPageHeader } from '../../ui/components/pure/page-headers/list/list-page-header.component';
import { usePermissionsMatrix } from './permissions-hook';
import { usePermissionsStyles } from './permissions.styles';

export function PermissionsPage({ params }: { params: ProjectPathParams<Paths.permissions> }) {
  const actions = usePermissionsMatrix(params.projectID);
  const classes = usePermissionsStyles();
  return (
    <>
      <ListPageHeader title="Permissions Matrix" />
      <TableContainer component={Paper} className={classes.table}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Allowed Action</TableCell>
              <TableCell>I Have This Action</TableCell>
              <TableCell>API Response</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {actions.map((action) => (
              <TableRow key={action.action}>
                <TableCell>{action.action}</TableCell>
                <TableCell>
                  {action.isMyAction ? (
                    <span className={classes.granted}>Yes</span>
                  ) : (
                    <span className={classes.denied}>No</span>
                  )}
                </TableCell>
                <TableCell>
                  <PermissionBoundary
                    permissions={[{ action: action.action, projectID: params.projectID }]}
                    notify={{
                      render() {
                        return <p className={classes.denied}>Denied</p>;
                      }
                    }}
                  >
                    <p className={classes.granted}>Granted</p>
                  </PermissionBoundary>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
